export function createHTMLAudio(
  url: string,
  onFailure?: (err: string) => void,
  onComplete?: () => void
): HTMLMediaElement | undefined | null {
  const audioNode = document.createElement('audio')

  // Check for errors or not supported devices
  const eventHandler = (e: Event) => {
    let warningText = ''

    if (e.target instanceof HTMLMediaElement && e.target.error) {
      switch (e.target.error.code) {
        case e.target.error.MEDIA_ERR_ABORTED:
          warningText = 'You aborted the question reading.'
          break
        case e.target.error.MEDIA_ERR_NETWORK:
          warningText = 'A network error caused the reading to fail.'
          break
        case e.target.error.MEDIA_ERR_DECODE:
          warningText = 'Reading question was aborted due to a corruption problem.'
          break
        case e.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
          warningText = 'There is no sound file for this word.'
          break
        default:
          warningText = 'An unknown error occured when reading questions.'
          break
      }
      if (onFailure) {
        onFailure(warningText)
      }
    }
  }

  if (audioNode instanceof HTMLMediaElement) {
    audioNode.setAttribute('src', url)
    if (onFailure) {
      audioNode.addEventListener('error', {handleEvent: eventHandler}, true)
    }
    if (onComplete) {
      audioNode.addEventListener('ended', onComplete)
    }
    return audioNode
  }
}
